import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import TwoColumnFormRow from "./TwoColumnFormRow";
import GarmentWithIcon from "./GarmentWithIcon";
import Box from "./Box";
import { useAppContext } from "./AppContext";

import SelectStandard from "./SelectStandard";

const RETURN_REASONS = [
  "Hole",
  "Stains",
  "Shrunk",
  "Bobbling",
  "Out of shape",
  "Other",
];

function ItemWithReturnReason({ item }) {
  const { takebackItems, setTakebackItems } = useAppContext();

  const [selectedValue, setSelectedValue] = useState("");

  const handleChange = (value) => {
    setSelectedValue(value);
  };

  useEffect(() => {
    const updatedItem = { ...item, reason: selectedValue };
    const updatedItems = takebackItems.map((i) =>
      i.id === item.id ? updatedItem : i
    );
    setTakebackItems(updatedItems);
  }, [selectedValue]);

  return (
    <Box
      backgroundColor="#ECECEC"
      mb="9px"
      borderRadius="4px"
      py={[20, null, 17, null]}
      minHeight={65}
    >
      <TwoColumnFormRow
        col1={
          <GarmentWithIcon
            name={`${item.name} (${item.category.name})`}
            icon={item.icon}
          />
        }
        col2={
          <SelectStandard
            name="Select reason"
            options={RETURN_REASONS.map((reason) => [reason, reason])}
            handleChange={handleChange}
            value={selectedValue}
          />
        }
      />
    </Box>
  );
}

ItemWithReturnReason.propTypes = {
  item: PropTypes.object.isRequired,
};

export default ItemWithReturnReason;
